import React from 'react';
import Checkbox from 'react-custom-checkbox';
import classNames from 'classnames';
import styles from './index.module.scss';

interface ICheckboxProps {
  icon?: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  onChange?: () => any;
  right?: boolean;
  name?: string;
  value?: number;
  size?: number;
  reference?: () => any;
  className?: string;
  borderColor?: string;
  borderRadius?: number;
  borderStyle?: any;
  borderWidth?: number;
  labelClassName?: string;
  labelStyle?: any;
  containerClassName?: string;
  containerStyle?: any;
  style?: any;
}

export default function CheckboxBase({ value, ...rest }: ICheckboxProps) {
  return (
    <Checkbox
      checked={value}
      className={styles.checkbox}
      icon={
        <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.iconContent)}>
          <svg className={`${styles.icon} icon`} aria-hidden="true">
            <use xlinkHref="#icon-done"></use>
          </svg>
        </div>
      }
      borderColor="#d8d8d8"
      borderWidth={value ? 0 : 1}
      borderRadius={2}
      size={16}
      {...rest}
    />
  );
}
